import React from 'react'
import {
  Text,
  Slide,
  Box,
  CloseButton,
  Flex,
  Spinner,
  Spacer,
} from '@chakra-ui/react'

const MeasurementsPlotContainer = ({
  children,
  isOpen,
  isLoading,
  onClose,
  point,
}) => {

  return (
    <Slide
      direction="bottom"
      in={isOpen}
      style={{ width: 600, height: 360, bottom: 0, zIndex: 1200 }}
    >
      <Box
        border="3px"
        borderColor="gray.500"
        backgroundColor={'white'}
        boxShadow="xl"
        borderBottomRightRadius={{ base: 'none', md: 10 }}
        borderTopRightRadius={{ base: 'none', md: 10 }}
        position="absolute"
        bottom={0}
        left={0}
        width={{ base: '100%', md: 600 }}
        height={360}
        zIndex={1200}
      >
        <Flex justify="space-between" p={3}>
          {!isLoading && point ? (
            <Box>
              <Box>
                <Text fontSize="sm" as="span">
                  Point id:{' '}
                </Text>
                <Text as="span" fontSize="sm" fontWeight="bold">
                  {point.properties.id}
                </Text>
              </Box>
              <Box>
                <Text fontSize="sm" as="span">
                  Reference id:{' '}
                </Text>
                <Text as="span" fontSize="sm" fontWeight="bold">
                  {point.properties.reference_id}
                </Text>
              </Box>
              <Box>
                <Text fontSize="sm" as="span">
                  Deformation rate:{' '}
                </Text>
                <Text as="span" fontSize="sm" fontWeight="bold">
                  {point.properties.deformation_rate} mm/y
                </Text>
              </Box>
              <Box>
                <Text fontSize="sm" as="span">
                  Coordinates:{' '}
                </Text>
                <Text as="span" fontSize="sm" fontWeight="bold">
                  Lat: {point.geometry.coordinates[1].toFixed(3)}° Lon:{' '}
                  {point.geometry.coordinates[0].toFixed(3)}°{' '}
                </Text>
              </Box>
            </Box>
          ) : typeof point === 'object' && !isLoading ? (
            <Text>There is not point at the selected area.</Text>
          ) : (
            <Spacer></Spacer>
          )}

          <CloseButton size="lg" onClick={onClose} />
        </Flex>
        <Flex align="center" justify="center" height="100%">
          {isLoading ? (
            <Spinner size="xl" color="teal.500" thickness="4px" />
          ) : (
            <Box height="100%" width="100%">
              {children}
            </Box>
          )}
        </Flex>
      </Box>
    </Slide>
  )
}

export default MeasurementsPlotContainer
